module.exports = __webpack_public_path__ + "static/img/logo6.bf69776.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo6.png
// module id = nWK9
// module chunks = 1